import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { instalarRecargaTrasDespliegue } from './lib/recargaTrasDespliegue'

instalarRecargaTrasDespliegue()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
